import React from "react";

import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api"
import Types from "constants/Types";
import APPCONFIG from "constants/Config";
import {Button} from "reactstrap";
import {Collections} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";
import ObjectOverride from "components/ObjectOverride";
import FFLTextField from "components/Elements/FFLTextField";


/**
 *  @property {Importers_Object} state
 *  @property {object} model
 *  @property {Importers_Properties} model.properties
 *  @property {Importers_Is} model.is
 *  @property {Importers_Has} model.has
 */
export default class formSixObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Importers._name);

	}

	/**
	 * @param prevProps
	 * @param {Importers_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		/** @type {Importers_Object} object */
		let object = this.state;

	}

	componentDidMount() {
		if(this.props.importer) {
			this.setState({
				name: this.props.importer.name,
				country_of_origin: this.props.importer.country_of_origin,
				full_address: this.props.importer.full_address,
				ffl_expiration: this.props.importer.ffl_expiration,
				ffl: this.props.importer.ffl,
				phone_number: this.props.importer.phone_number,
			})
		}
	}

	handleFormView = () => {
		window.open("https://www.atf.gov/firearms/docs/form/form-6a-release-and-receipt-imported-firearms-ammunition-and-implements-war-atf/download", "_blank");
	}


	async handleSubmit() {
		let imModel = new API.BuildClass(Types.Importers._name, API.RequestType.CREATE);
		this.request = 'PUT_FORM_6C';
		this.state.collection = this.props.collection;
		this.state.collection_binary_id = this.props.collection_binary_id;
		imModel.submit(this, 'PUT_FORM_6C');
		this.props.afterSave();
		if(this.props.collection) {
			this.props.history.push('/');
			this.props.history.push('/acquisitions/' + this.props.collection_binary_id + '-' + this.props.collection + '#forms');
		} else {
			this.props.history.push('/');
			this.props.history.push('/acquisitions/imports#forms');
		}
	}


	form = () => {
		/** @type {Importers_Properties} properties */
		let properties = this.model.properties;
		/** @type {Importers_Object} object */
		let object = this.state;
		let {loading} = this.state;

		// console.log('object in form six', this.state, this.props);
		return (
			<div>
				<fieldset>
					<div className={"row"}>
f
						<div className={"col-md"}>
							{/*#region Importer Information*/}
							<h4 className="section-title">1. Name and Address of Importer</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Importer Name"}
									property={properties.name}
									value={object.name}
									error={object.name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Importer Address"}
									property={properties.full_address}
									value={object.full_address}
									error={object.full_address_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<h4 className="section-title" style={{position: 'relative'}}>
								2. Name and Address of Foreign Seller
							</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Foreign Seller's Name"}
									property={properties.foreign_seller}
									value={object.foreign_seller}
									error={object.foreign_seller_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Foreign Seller's Full Address"}
									property={properties.foreign_seller_address}
									value={object.foreign_seller_address}
									error={object.foreign_seller_address_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>



							{/*#endregion*/}
							{/*#region Federal Firearms License*/}
							<h4 className="section-title" style={{position: 'relative'}}>
								3. Name and Address of Foreign Shipper
							</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Foreign Shipper's Name"}
									property={properties.foreign_shipper}
									value={object.foreign_shipper}
									error={object.foreign_shipper_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Foreign Shipper's Full Address"}
									property={properties.foreign_shipper_address}
									value={object.foreign_shipper_address}
									error={object.foreign_shipper_address_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>



							<h4 className="section-title" style={{position: 'relative'}}>
							    4. Federal License No. and/or AECA No. (if any)
							</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"4. Importer FFL"}
									property={properties.ffl}
									value={object.ffl}
									error={object.ffl_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.Date
									label={"FFL Expiration"}
									property={properties.ffl_expiration}
									value={object.ffl_expiration}
									error={object.ffl_expiration_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"AECA No."}
									property={properties.aeca}
									value={object.aeca}
									error={object.aeca_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.Date
									label={"AECA Expiration"}
									property={properties.aeca_expiration}
									value={object.aeca_expiration}
									error={object.aeca_expiration_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>


						</div>

						<div className={"col-md"}>

							<h4 className={"section-title"} style={{position: 'relative'}}>
								5. Country Where Manufactured
							</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Country Of Origin"}
									property={properties.country_of_origin}
									value={object.country_of_origin}
									error={object.country_of_origin_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>



							{/*#endregion*/}
							{/*#region Customers Broker*/}
							<h4 className="section-title" style={{position: 'relative'}}>
								6. Import Permit No.
							</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Permit Number"}
									property={properties.permit_number}
									value={object.permit_number}
									error={object.permit_number_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<h4 className="section-title">7. Telephone No.</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Phone Number"}
									property={properties.phone_number}
									value={object.phone_number}
									error={object.phone_number_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							{/*#endregion*/}

							{/*#region Contact Information*/}
							<h4 className="section-title">8. Gross Value of Shipment</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"$$$"}
									property={properties.gross_shipment_value}
									value={object.gross_shipment_value}
									error={object.gross_shipment_value_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div>

								<Button data-id="previous-product" onClick={this.handleFormView} size={"sm"}
								        color="info">
									<i className={"fa fa-barcode"}/>
									<span className="hidden-xs">&nbsp;&nbsp;View Form</span>
								</Button>
							</div>
							{/*#endregion*/}
							{/*#region Federal Firearms License*/}


						</div>

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
